import React from 'react';
import Title from '../layouts/Title';
import { projectOne, projectTwo } from "../../assets/index";
import ProjectsCard from './ProjectsCard';

const Projects = () => {
  return (
    <section
      id="projects"
      className="w-full py-20 border-b-[1px] border-b-black"
    >
      <div className="flex justify-center items-center text-center">
        <Title
          title="THINGS I'VE BUILT"
          des="Real Projects"
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-14">
        {/* ThreatEye Project */}
        <ProjectsCard
          title="ThreatEye - Security Scanner"
          des="Built a tool that scans websites for missing security headers and vulnerable parameters. It checks for CSP headers, X-Frame-Options, open redirects. Users log in with JWT, see their reports organized by severity."
          src={projectOne}
          githubLink="https://github.com/Kushalsharma0702/ThreatEye"
        />
        
        {/* VNC Exfiltration Detection */}
        <ProjectsCard
          title="VNC Detection System"
          des="Trained a machine learning model to spot abnormal VNC traffic patterns. Analyzed network capture files, extracted timing and packet size features, got 91% accuracy. Built a dashboard to visualize the results."
          src={projectTwo}
          githubLink="https://github.com/Kushalsharma0702/VNC-Exfiltration-Detection-System"
        />

        {/* Multilingual Voice Agent System */}
        <ProjectsCard
          title="Voice AI Backend"
          des="Connected speech-to-text, language processing, and speech synthesis into one backend. Handled async jobs properly, integrated multiple APIs, deployed to production."
          src={projectOne}
          liveLink="http://collections.intalksai.com/"
        />
      </div>
    </section>
  );
}

export default Projects;
